import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { ConfirmCodeSection } from '@/components/Auth/ConfirmCodeSection/ConfirmCodeSection';
import { LoginSection } from '@/components/Auth/LoginSection/LoginSection';
import { StringXSmall } from '@/components/Typography/Typography';
import { Logo } from '@/components/ui/Icons';

const Login: FC = () => {
  const { t } = useTranslation();
  const [loginStep, setLoginStep] = useState<1 | 2>(1);

  const nextLoginStep = (): void => {
    setLoginStep(2);
  };

  const prevLoginStep = (): void => {
    setLoginStep(1);
  };

  return (
    <main
      className={cn(
        'w-full h-full auth-bg pt-10 pb-9 flex flex-col items-center justify-between',
      )}
    >
      <Logo className="w-[clamp(100px,_6.95%,_200px)]" />
      {loginStep === 1 && <LoginSection nextLoginStep={nextLoginStep} />}
      {loginStep === 2 && <ConfirmCodeSection prevLoginStep={prevLoginStep} />}
      <StringXSmall className="!text-white/80">
        {t('© Star Industry {{value}} All rights reserved.', {
          value: new Date().getFullYear(),
        })}
      </StringXSmall>
    </main>
  );
};

export { Login };
